import { render, staticRenderFns } from "./ConsultasHistorico.vue?vue&type=template&id=6f6d0cb3&scoped=true"
import script from "./ConsultasHistorico.vue?vue&type=script&lang=js"
export * from "./ConsultasHistorico.vue?vue&type=script&lang=js"
import style0 from "./ConsultasHistorico.vue?vue&type=style&index=0&id=6f6d0cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6d0cb3",
  null
  
)

export default component.exports